/* ============================================================
   PDP v2 – Best-Practice-Layer
   Aktivierung: GrowthBook-Flag "pdp-redesign" (Experiment-backed,
   Exposure feuert automatisch in dataLayer/GA4) oder ?pdpv2=on|off (QA).
   Control = aktuelle PDP (Layer bleibt unsichtbar).
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-pdp2]');
    if (!root || root.dataset.pdp2Init === '1') return;
    root.dataset.pdp2Init = '1';

    // ---------- Aktivierung (Controller für v2 UND v3) ----------
    // Flag "pdp-version": "control" | "v2" | "v3". Priorität: URL-Override > GrowthBook.
    // v3 nur auf Seiten mit v3-Markup ([data-pdp3], Standard-PDPs) – sonst Fallback auf v2.
    var activated = false;

    // Anti-Flicker-Skeleton (pdp-anti-flicker.liquid) aufdecken, sobald die
    // Versions-Entscheidung gefallen ist (Failsafe nach 1500ms macht es ohnehin).
    function reveal() { document.documentElement.removeAttribute('data-pdp-af'); }

    function applyVersion(ver) {
      if (activated) { reveal(); return; }
      ver = String(ver || '').toLowerCase();
      if (ver === 'v3' && !document.querySelector('[data-pdp3]')) ver = 'v2';
      if (ver === 'v3') {
        activated = true;
        document.documentElement.classList.add('pdp-v3-on');
        document.dispatchEvent(new CustomEvent('pdp:version', { detail: 'v3' }));
      } else if (ver === 'v2') {
        activated = true;
        document.documentElement.classList.add('pdp-v2-on');
        document.dispatchEvent(new CustomEvent('pdp:version', { detail: 'v2' }));
        mount();
      }
      // "control"/unbekannt -> nichts tun
      reveal();
    }

    // URL-Overrides: ?pdpv=control|v2|v3 (neu) bzw. ?pdpv2=on|off (legacy)
    var qs = new URLSearchParams(location.search);
    var pv = (qs.get('pdpv') || '').toLowerCase();
    if (['control', 'v2', 'v3'].indexOf(pv) > -1) {
      if (pv !== 'control') applyVersion(pv);
      else reveal();
      return;
    }
    var legacy = qs.get('pdpv2');
    if (legacy !== null) {
      legacy = legacy.toLowerCase();
      if (['on', '1', 'true'].indexOf(legacy) > -1) { applyVersion('v2'); return; }
      if (['off', '0', 'false'].indexOf(legacy) > -1) { reveal(); return; }
    }

    // GrowthBook-Poll (gleiches Muster wie gift-collection.js / Store-Standard)
    var tries = 0;
    (function poll() {
      var gb = window._growthbook || window.growthbook || window.gb;
      if (gb && gb.ready && typeof gb.getFeatureValue === 'function') {
        var ver = gb.getFeatureValue('pdp-version', null);
        if (typeof ver === 'string') applyVersion(ver);
        else reveal();
        return;
      }
      if (tries++ < 30) setTimeout(poll, 100);
      else reveal();
    })();

    // ---------- v2-Elemente an Zielpositionen montieren ----------
    var mounted = false;
    function mount() {
      if (mounted) return;
      mounted = true;

      var isCustom = root.getAttribute('data-pdp2-custom') === 'true';

      function visible(el) { return !!(el && el.offsetParent !== null); }
      function firstVisible(sel) {
        var els = document.querySelectorAll(sel);
        for (var i = 0; i < els.length; i++) if (visible(els[i])) return els[i];
        return els[0] || null;
      }

      // Ziel-Anker im bestehenden Markup (sichtbare Instanz bevorzugen – Theme hat teils versteckte Duplikate)
      var priceEl = firstVisible('.sl-product__price');
      var atcBtn = firstVisible('[data-add-to-cart]');
      var form = atcBtn ? atcBtn.closest('form') || atcBtn.parentElement : firstVisible('.sl-product-form');

      // 1. Geschenk-Badge hinter den Preis
      var gift = root.querySelector('[data-pdp2-gift]');
      if (gift && priceEl) {
        var priceWrap = priceEl.closest('div') || priceEl;
        priceWrap.insertAdjacentElement('afterend', gift);
      }

      // 2. Liefer-/Trust-Block unter den ATC-Button
      var below = root.querySelector('[data-pdp2-belowatc]');
      if (below && form) form.insertAdjacentElement('afterend', below);

      // 3. Promo-Code: Tap-to-Copy (KEIN Auto-Apply – Kunde gibt ihn an der Kasse ein)
      var copyBtn = root.querySelector('[data-pdp2-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var code = copyBtn.getAttribute('data-pdp2-copy');
          function done() {
            var orig = copyBtn.childNodes[0].textContent;
            copyBtn.childNodes[0].textContent = 'Kopiert ✓';
            setTimeout(function () { copyBtn.childNodes[0].textContent = orig; }, 1800);
          }
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done).catch(function () {});
          else done();
        });
      }

      // 4. Sticky-Bar an den Body, Sichtbarkeit via IntersectionObserver auf dem ATC
      var sticky = root.querySelector('[data-pdp2-sticky]');
      if (sticky) {
        document.body.appendChild(sticky);
        sticky.removeAttribute('aria-hidden');

        var cta = sticky.querySelector('[data-pdp2-sticky-cta]');
        if (cta) {
          cta.addEventListener('click', function () {
            if (isCustom || !atcBtn) {
              // Gravur-/Konfigurator-Produkte: zum Formular scrollen (Validierung sichtbar)
              var target = form || document.querySelector('.sl-product-form') || document.body;
              target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
              // Standard-Produkte: echten ATC auslösen -> Theme-Flow (Slide-Cart) übernimmt
              atcBtn.click();
            }
          });
        }

        // Preis live spiegeln (Variantenwechsel ändert .sl-product__price)
        var stickyPrice = sticky.querySelector('[data-pdp2-sticky-price]');
        if (stickyPrice && priceEl) {
          var sync = function () {
            var t = (priceEl.textContent || '').trim().replace(/\s+/g, ' ');
            if (t) stickyPrice.textContent = t;
          };
          sync();
          new MutationObserver(sync).observe(priceEl, { childList: true, subtree: true, characterData: true });
        }

        // Sichtbar, sobald am ATC vorbeigescrollt wurde. Vergleich gegen die Dokument-
        // Position des Ankers beim Mount (robust auch bei gepinnten Buy-Boxen, deren
        // Viewport-Position sich beim Scrollen nicht ändert – z.B. Configurable-Template).
        var anchor = (visible(atcBtn) && atcBtn) || (visible(form) && form) || null;
        var anchorDocBottom = 400;
        if (anchor) {
          var ar = anchor.getBoundingClientRect();
          anchorDocBottom = Math.max(200, ar.bottom + window.scrollY);
        }
        function updateSticky() {
          var show = window.scrollY > anchorDocBottom + 80;
          if (anchor && !show) show = anchor.getBoundingClientRect().bottom < 0;
          sticky.classList.toggle('is-visible', show);
        }
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky, { passive: true });
        updateSticky();
      }

      root.style.display = '';
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
